import {
  createRouter as createVueRouter,
  createMemoryHistory,
  createWebHistory,
} from "vue-router";
import HomePage from "@/pages/HomePage.vue";
import NotFoundPage from "@/pages/404.vue";

const routes = [
  {
    path: "/",
    redirect: { name: "NotFoundPage" }, // ⬅️ Tambahan ini untuk handle akses tanpa slug
  },
  {
    path: "/:slug",
    name: "home",
    component: HomePage,
  },
  {
    path: "/not-found",
    name: "NotFoundPage",
    component: NotFoundPage,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "NotFoundPage" },
  },
];

const isServer = typeof window === "undefined";

const createRouter = () =>
  createVueRouter({
    history: isServer
      ? createMemoryHistory()
      : createWebHistory(process.env.BASE_URL),
    routes,
  });

export default createRouter;
